import React, { FC } from 'react';

import type { ControlButtonType } from '@/shared/types/notifications';

interface Props {
    buttonType: ControlButtonType;
    adButtonText?: string;
}

export const ControlButtonIcon: FC<Props> = ({ buttonType, adButtonText }) => {
    switch (buttonType) {
        case 'close':
            return (
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none">
                    <path
                        style={{ fill: 'currentcolor' }}
                        d="m12.666 3.326.566.566-4.101 4.1 4.101 4.102-.566.565-.565.567-4.102-4.102-4.1 4.102-.566-.567-.565-.565 4.1-4.102-4.1-4.1 1.13-1.131L8 6.86l4.102-4.1.565.565Z"
                    />
                </svg>
            );
        case 'info':
            return (
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none">
                    <path style={{ stroke: 'currentcolor' }} strokeWidth="2" d="M8 7v7" />
                    <circle style={{ fill: 'currentcolor' }} cx="8" cy="3.5" r="1.5" />
                </svg>
            );
        case 'ad':
            return (
                <>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="2"
                        height="8"
                        viewBox="0 0 2 8"
                        fill="none"
                    >
                        <circle style={{ fill: 'currentcolor' }} cx="1" cy="1" r="1" />
                        <circle style={{ fill: 'currentcolor' }} cx="1" cy="4" r="1" />
                        <circle style={{ fill: 'currentcolor' }} cx="1" cy="7" r="1" />
                    </svg>
                    {adButtonText && <span>{adButtonText}</span>}
                </>
            );
        default:
            return null;
    }
};
